import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CalAngularService, ICvxClaimsPrincipal } from '@cvx/cal-angular';
import { LFDAPIService } from 'src/app/core/services/api';
import { DataService } from 'src/app/core/services/data_service';
import { MsGraphService } from 'src/app/core/services/ms-graph';
import { SessionStorageService } from 'src/app/core/services/session_storage';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { ApplicationRole } from '../../models/ApplicationRole';
import { c } from '@angular/core/navigation_types.d-u4EOrrdZ';
import { Constants } from 'src/app/constants/constants';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.less'],
    standalone: false
})
export class PageHeaderComponent implements OnInit, OnDestroy{
  @Input() displayStatus = false;
  userName: string = '';
  userPhoto: any;
  currentUserProfile!: ICvxClaimsPrincipal;
  currentStatus!: number;
  currentStep = 0;
  user: User = new User();
  msgText: string = "";
  timeLeft: string = ''; // Time left for token expiration
  private intervalId: any;
  isDisplaySessionTimer: boolean = false;
  constructor(private msgraph: MsGraphService,
    private sanitizer: DomSanitizer, 
    private session: SessionStorageService,
    private userService: UserService){} 

    
  ngOnInit(){    
    
    this.user = this.userService.getCurrentUser();
    if (environment.production === false) {
      this.isDisplaySessionTimer = true;
    }    
    // Subscribe to the userUpdated event
    this.userService.userUpdated.subscribe((updatedUser: User) => {
      this.user = updatedUser;      
      this.updateTimeLeft(); // Initial calculation
      this.intervalId = setInterval(() => this.updateTimeLeft(), 1000); // Update every second
    });
  }
  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId); // Clear the interval when the component is destroyed
    }
  }

  
  getAndSetPhoto() {       
    this.msgraph.getUserPhoto().subscribe(data => {
      let jsonKey: string = "";
      new Uint8Array(data).forEach(function(byte:number){jsonKey+=String.fromCharCode(byte)})
      let base64String = btoa(jsonKey);
      localStorage.setItem('photo', base64String);
      this.userPhoto = this.sanitizer.bypassSecurityTrustUrl(
        'data:image/*;base64, ' + base64String
      );
    });
  }
  private updateTimeLeft(): void {
    const tokenExp = this.session.getItem(Constants.TOKEN_EXPIRATION_KEY);
    if (tokenExp) {
      const expirationTime = parseInt(tokenExp, 10) * 1000; // Convert to milliseconds
      const currentTime = Date.now();
      const timeDiff = expirationTime - currentTime;

      if (timeDiff > 0) {
        const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
        const seconds = Math.floor((timeDiff / 1000) % 60);
        this.timeLeft = `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      } else {
        this.timeLeft = 'Expired';
      }
    } else {
      this.timeLeft = 'Unknown';
    }
  }
  

}
